import { MainCategories } from '../yome-categories-fields-config/models/fields.model'
// eslint-disable-next-line import/prefer-default-export
export const quickMessagePromptsMap: Record<MainCategories, string[]> = {
  [MainCategories.services]: ['available', 'urgent', 'start', 'howMuch'],
  [MainCategories.others]: ['selling', 'negotiable', 'look', 'delivery'],
}
